// extracted by mini-css-extract-plugin
export default {"comingSoonContainer":"comingSoon_comingSoonContainer__qGaMX","comingSoonImg":"comingSoon_comingSoonImg__NM7Dc"};